import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'
import {ExperimentalFeatureFlagType} from '@toolify/server/src/models/mongoose/UserModel/enum/ExperimentalFeatureFlagType'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {ResourceTypeColorMap} from '@toolify/client/src/modules/resources/maps/ResourceTypeColorMap'

export function resolveResourceTypeIconColor(
  resourceType: ResourceType | null | undefined,
  isEnabled: boolean,
): string | undefined {
  if(!isEnabled || !resourceType) {
    return undefined
  }
  return ResourceTypeColorMap.get(resourceType)
}

function isResourceTypeIconColorEnabled(): boolean {
  const authStore = useAuthStore()
  const user = authStore.currentEntity?.entityType === EntityType.User
    ? authStore.currentEntity.payload as IUserResponseInstance
    : null
  return user?.experimentalFeatureFlags?.includes(ExperimentalFeatureFlagType.EnableResourceTypeIconColors) ?? false
}

export function getResourceTypeIconColor(resourceType?: ResourceType | null): string | undefined {
  return resolveResourceTypeIconColor(resourceType, isResourceTypeIconColorEnabled())
}

export function getResourceTypeIconStyle(resourceType?: ResourceType | null): {color: string} | undefined {
  const color = getResourceTypeIconColor(resourceType)
  return color ? {color} : undefined
}
